import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

const TitlePage = (props) => {
  const { label } = props

  return (
    <Typography
      className="text-18 text-primary font-medium"
      component="h2"
      variant="h6"
    >
      {label}
    </Typography>
  )
}

TitlePage.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default TitlePage
